import { createBrowserRouter, Navigate } from "react-router-dom";
import { ChatbotProvider } from "../provider/chatbot_provider";
import Chatbot from "../views/chatbot";
import Landing from "../views/landing";
import Login from "../views/login";
import PrivateRoute from "./privateRoute";
import ErrorBoundary from "./ErrorBoundary";
import PageNotFound from "../components/PageNotFound";
import Competitor from "../views/competitor";
import { CompetitorProvider } from "../provider/competitor_provider";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PrivateRoute />,
    // element: <Outlet />,
    hasErrorBoundary: true,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "/",
        element: <Navigate to="/dashboard" />,
      },
      {
        path: "/dashboard",
        element: <Landing />,
      },
      {
        path: "/people",
        element: (
          <ChatbotProvider tool={"hr"}>
            <Chatbot tool="Chat @ People" />
          </ChatbotProvider>
        ),
      },
      // {
      //   path: "/company",
      //   element: (
      //     <ChatbotProvider tool={"competitor"}>
      //       <Chatbot tool="Chat @ Company" />
      //     </ChatbotProvider>
      //   ),
      // },
      {
        path: "/company",
        children: [
          {
            path: "/company/segmentwise",
            element:
              <CompetitorProvider tool={"competitor"}>
                <Competitor tool="AMA @ Company" />
              </CompetitorProvider>
          },
          {
            path: "/company/nl",
            element:
              <CompetitorProvider tool={"competitor"}>
                <Competitor tool="AMA @ Company" />
              </CompetitorProvider>
          },
          {
            path: "/company/annual",
            element:
              <CompetitorProvider tool={"competitor"}>
                <Competitor tool="AMA @ Company" />
              </CompetitorProvider>
          }
        ],
        element: (
          <CompetitorProvider tool={"competitor"}>
            <Competitor tool="Chat @ Company" />
          </CompetitorProvider>
        ),
      },
      {
        path: "/product",
        element: (
          <ChatbotProvider tool={"catalog"}>
            <Chatbot tool="Chat @ Product" />
          </ChatbotProvider>
        ),
      },
      {
        path: "/document",
        element: (
          <ChatbotProvider tool={"document"}>
            <Chatbot tool="Chat @ Document" />
          </ChatbotProvider>
        ),
      },
      {
        path: "/legal",
        element: (
          <ChatbotProvider tool={"legal"}>
            <Chatbot tool="Chat @ Legal AI - Petition" />
          </ChatbotProvider>
        ),
      },
      {
        path: "/qc",
        element: (
          <ChatbotProvider tool={"qc"}>
            <Chatbot tool="Chat @ QC" />
          </ChatbotProvider>
        ),
      },
      {
        path: "/kyp",
        element: (
          <ChatbotProvider tool={"kyp"}>
            <Chatbot tool="Chat @ KYP" />
          </ChatbotProvider>
        ),
      },
      {
        path: "/help",
        element: (
          <ChatbotProvider tool={"help"}>
            <Chatbot tool="Chat @ Help" />
          </ChatbotProvider>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

export default router;
